const slideNumber = splide => {
  let arrows;

  const update = () => {
    arrows.setAttribute(
      'data-slide-number',
      `${splide.index + 1} / ${splide.length}`,
    );
  };

  const mount = () => {
    arrows = splide.Components.Arrows.arrows.prev.parentElement;

    update();
    splide.on('move', update);
  };

  return {
    mount,
  };
};

export default slideNumber;
